exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name[data-v-29797988]{font-weight:700}.change[data-v-29797988]{font-size:11px}.qrcode-text-btn[data-v-29797988]{display:inline-block;cursor:pointer;margin-top:15px}.qrcode-text-btn>input[type=file][data-v-29797988]{position:absolute;overflow:hidden;width:0;height:0;opacity:0}#video[data-v-29797988]{-o-object-fit:fill;object-fit:fill}.postal-code[data-v-29797988]{padding:5px 0 0 10px;border:1px solid gray;background-color:#fff}.takeaway-contact[data-v-29797988]{padding:5px 0 0 10px;background-color:#fff;margin:10px}.smaller[data-v-29797988]{font-size:12px}.grey-color[data-v-29797988]{color:#8a8a8a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29797988","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SettingDialog.vue
// module id = sjTJ
// module chunks = 0